import { IconFileInvoice, IconPlus } from "@tabler/icons-react";
import { Button, Card, Group, Heading, Skeleton, Stack, Text, ThemeIcon } from "@/components/ui";

/** Loading placeholder · 5 filas skeleton. */
export function SkeletonList() {
  return (
    <Card padding="lg">
      <Stack gap="md">
        {Array.from({ length: 5 }).map((_, i) => (
          <Group key={i} gap="md">
            <Skeleton height={20} width={60} />
            <Skeleton height={20} width={100} />
            <Skeleton height={20} className="flex-1" />
            <Skeleton height={20} width={80} />
          </Group>
        ))}
      </Stack>
    </Card>
  );
}

/** Estado vacío · usuario sin solicitudes · CTA a crear. */
export function EmptyState({ onCrear }: { onCrear: () => void }) {
  return (
    <Card padding="xl">
      <Stack align="center" gap="md" className="py-8">
        <ThemeIcon variant="filled" color="multiva" size="xl">
          <IconFileInvoice size={28} stroke={1.4} />
        </ThemeIcon>
        <Stack gap={4} align="center">
          <Heading order={4}>Aún no tienes solicitudes</Heading>
          <Text size="sm" c="dimmed" ta="center" className="max-w-100">
            Crea tu primera solicitud de pago · subir un CFDI, capturar datos generales, asignar proveedor, prorratear
            y enviar a autorización.
          </Text>
        </Stack>
        <Button leftSection={<IconPlus size={16} />} onClick={onCrear}>
          Crear primera solicitud
        </Button>
      </Stack>
    </Card>
  );
}

/** Estado vacío por filtros · CTA a limpiar. */
export function EmptyFiltro({ onLimpiar }: { onLimpiar: () => void }) {
  return (
    <Card padding="lg">
      <Stack align="center" gap="sm" className="py-4">
        <Text size="sm" c="dimmed">
          No hay solicitudes con esos filtros.
        </Text>
        <Button size="xs" variant="light" onClick={onLimpiar}>
          Limpiar filtros
        </Button>
      </Stack>
    </Card>
  );
}
